import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ApiResponse, FilterParams, City } from "../../types/types";

export const goodsApi = createApi({
  reducerPath: "goodsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://back.skynet-service.com/api",
    prepareHeaders: (headers) => {
      headers.set("Accept", "application/json");
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  tagTypes: ["Goods", "Cities"],
  endpoints: (builder) => ({
    getGoods: builder.mutation<ApiResponse, Partial<FilterParams>>({
      query: (params) => ({
        url: "/list-pricelist",
        method: "POST",
        body: {
          countOnPage: params.countOnPage || 500,
          page: params.page || "1",
          product: params.product || "all",
          q: params.q || "",
          sort: params.sort || 1,
          city: params.city || 0,
        },
      }),
    }),
    getCities: builder.query<City[], void>({
      query: () => "/list-cities",
      providesTags: ["Cities"],
    }),
  }),
});

export const { useGetGoodsMutation, useGetCitiesQuery } = goodsApi;
